var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorklistStatusLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8ZM3.45 8C3.45 10.5129 5.4871 12.55 8 12.55C10.5129 12.55 12.55 10.5129 12.55 8C12.55 5.4871 10.5129 3.45 8 3.45C5.4871 3.45 3.45 5.4871 3.45 8Z",
    fill: "#0F1215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C9.28558 1.5 10.5423 1.88122 11.6112 2.59545C12.6801 3.30968 13.5132 4.32484 14.0052 5.51256C14.4972 6.70028 14.6259 8.00721 14.3751 9.26809C14.1243 10.529 13.5052 11.6872 12.5962 12.5962C11.6872 13.5052 10.529 14.1243 9.26809 14.3751C8.00721 14.6259 6.70028 14.4972 5.51256 14.0052C4.32484 13.5132 3.30968 12.6801 2.59545 11.6112C1.88122 10.5423 1.5 9.28558 1.5 8H3.45C3.45 8.8999 3.71685 9.7796 4.21681 10.5278C4.71677 11.2761 5.42739 11.8593 6.25879 12.2037C7.09019 12.548 8.00505 12.6381 8.88766 12.4626C9.77027 12.287 10.581 11.8537 11.2173 11.2173C11.8537 10.581 12.287 9.77027 12.4626 8.88766C12.6381 8.00505 12.548 7.09019 12.2037 6.25879C11.8593 5.42739 11.2761 4.71677 10.5278 4.21681C9.7796 3.71685 8.89991 3.45 8 3.45V1.5Z",
    fill: "#007AD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorklistStatusLoading);
export default __webpack_public_path__ + "static/media/worklist-status-loading.a193a7707d8d02fbe773b4b34d2ef034.svg";
export { ForwardRef as ReactComponent };